import type { PollService } from "@busbud/core-types";
import type { Amenity } from "@busbud/int-schemas/udm";

import type { NapiV2CartSegment } from "@app/types/napi-v2-cart-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { SearchInfo } from "@app/types/search-types";

import { getLegSegmentsFromTrip } from "./trip";

export const getLegAmenityListFromTrip = (
  search: SearchInfo,
  trip: PollService.API.RelatedPublicTrip | PollService.API.RelatedPublicTripV4,
  trips_segments: ResultsReduxState["trips_segments"]
) => {
  const segments = getLegSegmentsFromTrip(search, trip, trips_segments);

  return reducerSegmentsAmenities(segments);
};

export const reducerSegmentsAmenities = (
  segments: (
    | NapiV2CartSegment
    | PollService.API.RelatedPublicSegment
    | PollService.API.RelatedPublicSegmentV4
  )[]
) => {
  const leg_amenities: Partial<Record<Amenity, boolean>> = {};

  return segments.reduce((leg_amenities, segment) => {
    return (segment.vehicle?.amenities || []).reduce(
      (leg_amenities, amentity) => {
        leg_amenities[amentity] = true;
        return leg_amenities;
      },
      leg_amenities
    );
  }, leg_amenities);
};
